export const getLogoURL = customSettings => {
    if (customSettings && customSettings.logoURL !== "") {
      return customSettings.logoURL;
    } else {
      return process.env.LOGO_URL;
    }
  };
  export const getFooterURL = customSettings => {
    if (customSettings && customSettings.organizationURL !== "") {
      return customSettings.organizationURL;
    } else {
      return process.env.LOGO_URL;
    }
  };


// WEBPACK FOOTER //
// ./src/helpers/getCustomSettings.js